<adxad-modal-close-btn (click)="closeModal()"></adxad-modal-close-btn>

<adxad-modal-header>
  <h2 adxadModalTitle>{{ 'promotionTerms' | transloco }}</h2>
</adxad-modal-header>

<adxad-modal-content> {{ 'termsText' | transloco }} </adxad-modal-content>
